import { get } from 'radash';

import { diagram } from '@diagram/state/diagram';
import { Helpers, SideEffect } from '@diagram/state/effects/diagram/helpers';

import { SyncEngineHelpers } from 'helpers/SyncEngineHelpers';

const syncComponentGenericVoltageTypes: SideEffect = (change) => {
    const { type, data } = change;

    if (type === 'delete') return;

    for (const [path, value] of Object.entries(data)) {
        const match = Helpers.matchComponentInstance<{
            port: string;
            voltageType: 'AC' | 'DC';
            property: string;
        }>(
            path,
            /specifications\.electrical\.ports\.(?<port>\d+)\.(?<voltageType>AC|DC)\.(?<property>voltage|current|power)$/,
        );

        if (!match) {
            continue;
        }

        const { id, port, property, voltageType } = match;

        const componentInstance = diagram.componentInstances[id];

        if (!componentInstance) {
            // TODO Remove in the future.
            console.warn(`Couldn't find component instance ${id} in syncComponentGenericVoltageTypes`, change);
        }

        if (componentInstance && !componentInstance.componentId) {
            const existingValue = get(
                componentInstance,
                `specifications.electrical.ports.${port}.${voltageType}.${property}`,
            );

            if (existingValue !== undefined) {
                SyncEngineHelpers.set(
                    componentInstance,
                    `specifications.electrical.ports.${port}.${voltageType === 'AC' ? 'DC' : 'AC'}.${property}`,
                    value,
                );
            }
        }
    }
};

export { syncComponentGenericVoltageTypes };
